import styled from 'styled-components';

const MainContent = styled.div`
    flex: 1;
    padding: 20px;
    margin-top: 20px;
    //margin: 20px;
    //background-color: #ffffff;
    //border-radius: 10px;
    //box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    overflow-y: auto;
`;

export default MainContent;